import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Spin, Typography } from 'antd';
import moment from 'moment-timezone';

import BookingCard from 'components/booking-card';
import Client from 'containers/app/client';

import './style.css';
import { useCollection } from 'react-firebase-hooks/firestore';

const RequestCard = ({ request, id }) => {
  const [loadingAccept, setLoadingAccept] = useState(false);
  const [loadingDecline, setLoadingDecline] = useState(false);
  const { dateStart, dateEnd, rate, status, userId: employer } = request;
  const actions = [];
  const expired = moment(dateStart).isBefore(moment());
  const fStatus = expired ? 'expired' : status;

  // get organisatio details
  const orgRef = Client.db
    .collection('organizations')
    .where('userId', '==', employer);
  const [collection, loading, error] = useCollection(orgRef);
  
  if (loading) return <Spin />;
  if (error) throw error;

  // get first record as we should only have one matching organisation
  let organisation;
  // eslint-disable-next-line array-callback-return
  collection.docs.filter((doc) => { organisation = doc.data(); });

  if (fStatus !== 'cancelled') {
    actions.push(
      <Button
        type="primary"
        danger
        onClick={async () => {
          setLoadingDecline(true);
          await Client.rejectBookingRequest({ id, ...request });
          setLoadingDecline(false);
        }}
        loading={loadingDecline}
        disabled={loadingAccept || loadingDecline}
      >
        {fStatus !== 'expired' ? 'Decline' : 'Delete'}
      </Button>
    );
  }

  if (fStatus !== 'cancelled' && fStatus !== 'expired') {
    actions.push(
      <Button
        loading={loadingAccept}
        disabled={loadingAccept || loadingDecline}
        type="primary"
        onClick={async () => {
          setLoadingAccept(true);
          await Client.acceptBookingRequest({
            employer,
            bookingRequest: id,
          });
          setLoadingAccept(false);
        }}
      >
        Accept
      </Button>
    );
  }

  return (
    <BookingCard
      profile={`/employer-detail/${request.userId}`}
      className="booking-request-card"
      actions={actions}
      request={request}
      user={employer}
      organisation={organisation}
    >
      <Typography>
        <p>
          You have a {fStatus} request for{' '}
          <strong>{moment.utc(dateStart).format('dddd DD of MMMM')}</strong> to{' '}
          <strong>{moment.utc(dateEnd).format('dddd DD of MMMM')}</strong>.{' '}
          <br />
          Shift time <strong>{moment.utc(dateStart).format('HH:mm')}</strong>-
          <strong>{moment.utc(dateEnd).format('HH:mm')}</strong>
        </p>
        <p>
          With a proposed hour Rate of <strong>£{rate}</strong>
        </p>
      </Typography>
    </BookingCard>
  );
};

RequestCard.propTypes = {
  id: PropTypes.string.isRequired,
  request: PropTypes.shape({
    dateStart: PropTypes.string,
    dateEnd: PropTypes.string,
    rate: PropTypes.number,
    worker: PropTypes.string,
    status: PropTypes.string,
    userId: PropTypes.string,
  }).isRequired,
};

export default RequestCard;
